import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { NgModule, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { App } from './app';
import { AppRoutingModule } from './app-routing-module';
import { ACCESS_TOKEN_INTERCEPTOR } from './core/libraries/http-interceptor/access-token.interceptor';
import { UNAUTHORIZED_REFRESH_TOKEN_INTERCEPTOR } from './core/libraries/http-interceptor/unauthorized-refresh-token.interceptor';

@NgModule({
    declarations: [App],
    imports: [BrowserModule, AppRoutingModule],
    providers: [
        provideHttpClient(
            withFetch(),
            withInterceptors([ACCESS_TOKEN_INTERCEPTOR, UNAUTHORIZED_REFRESH_TOKEN_INTERCEPTOR]),
        ),
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideClientHydration(withEventReplay()),
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
        provideFirestore(() => getFirestore()),
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: {
                width: '500px',
                autoFocus: false,
                disableClose: true,
            },
        },
    ],
    bootstrap: [App],
})
export class AppModule {}
